/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Deals_Section_TitleInputs */

const en_directory_hubs_deals_section_title = /** @type {(inputs: Directory_Hubs_Deals_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured community offers`)
};

const zh_directory_hubs_deals_section_title = /** @type {(inputs: Directory_Hubs_Deals_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选社区优惠`)
};

/**
* | output |
* | --- |
* | "Featured community offers" |
*
* @param {Directory_Hubs_Deals_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_deals_section_title = /** @type {((inputs?: Directory_Hubs_Deals_Section_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Deals_Section_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_deals_section_title(inputs)
	return zh_directory_hubs_deals_section_title(inputs)
});
export { directory_hubs_deals_section_title as "directory.hubs.deals.section_title" }